import * as Yup from 'yup';

const amanha = () => {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  d.setHours(0, 0, 0, 0);
  return d;
};

export const schemaIncluirIsencao = Yup.object().shape({
  codigo_grupo_empresa: Yup.number()
    .required('GE é obrigatória')
    .positive()
    .integer(),
  codigo_conta: Yup.number()
    .required('Conta é obrigatória')
    .positive()
    .integer(),
  motivo: Yup.string()
    .required('Motivo é obrigatório')
    .trim()
    .min(3, 'Motivo deve ter no mínimo 3 caracteres')
    .max(200),
  validade: Yup.date()
    .required('Validade é obrigatória')
    .min(amanha(), 'Validade deve ser uma data futura'),
});

export const schemaExcluirIsencao = Yup.object().shape({
  motivo: Yup.string()
    .required('Informe o motivo')
    .trim()
    .min(3, 'Motivo deve ter no mínimo 3 caracteres')
    .max(200),
});

export const schemaAlterarValidadeLote = Yup.object().shape({
  nova_validade: Yup.date()
    .required('Necessário informar uma nova data de validade')
    .min(amanha(), 'Validade deve ser uma data futura'),
  motivo: Yup.string()
    .required('Motivo é obrigatório')
    .trim()
    .min(3, 'Motivo deve ter no mínimo 3 caracteres')
    .max(200),
});
